import { render } from "./CarrierDetailModal.vue?vue&type=template&id=57cdfd5a&ts=true"
import script from "./CarrierDetailModal.vue?vue&type=script&lang=ts"
export * from "./CarrierDetailModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__